// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container___QyIb","box":"styles_box__kzMEi","icon":"styles_icon__EjuyH"};